export function include(arr,obj) {
    return (arr.indexOf(obj) !== -1);
}
